// Compile-time exhaustiveness guard for the analytics event switches. Reaching it means a TtvAnalyticsEvent variant was added without a case, and the `never` parameter turns that into a type error at the switch rather than a payload that quietly ships with no properties.
export const assertNever = (value: never): never => {
  throw new Error(
    `Unhandled TTV analytics event variant: ${JSON.stringify(value)}`
  );
};
